var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a = require('../sparql/tokens'), sparqlTokenMap = _a.sparqlTokenMap, stardogSparqlTokens = _a.stardogSparqlTokens;
import { createToken } from 'chevrotain';
import { createKeyword } from '../sparql/keywords';
var FROM_BLOCK_END_MATCHER = /^\s*to\s*{/i;
var FROM_JSON_BLOCK_END_MATCHER = /((?:.|\s)*?)to\s*{/i;
// Because the end of `FROM` clauses in SMS are not explicit, tokenizing them
// using regexes can be incredibly inefficient. This function gives us a bit
// more control; it scans through the document character by character until
// it finds a character which is _likely_ to be followed by an ending pattern,
// and only then does it use a regex to confirm.
var explicitEndMatcher = function (textToMatch, endCandidateChar, // Char which, if found, triggers an exec of endMatcher
endMatcher // Regex which matches an end pattern
) {
    for (var offset = 0, char = void 0; offset < textToMatch.length; offset++) {
        char = textToMatch[offset];
        if (char === endCandidateChar) {
            var blockEndCandidate = textToMatch.slice(offset + 1);
            var match = endMatcher.exec(blockEndCandidate);
            if (!match) {
                continue;
            }
            else {
                var blockText = textToMatch.slice(0, offset);
                var response = [blockText];
                return response;
            }
        }
    }
    return null;
};
export var smsTokenMap = __assign({}, sparqlTokenMap, { Template: createKeyword({ name: 'Template' }), Sql: createKeyword({ name: 'Sql' }), GraphQl: createKeyword({ name: 'GraphQl' }), Json: createKeyword({ name: 'Json' }), Csv: createKeyword({ name: 'Csv' }), Mapping: createKeyword({ name: 'Mapping' }), SqlBlock: createToken({
        name: 'SqlBlock',
        pattern: function (text, startOffset, matchedTokensSoFar) {
            if (startOffset === void 0) { startOffset = 0; }
            var _a = matchedTokensSoFar.slice(-2), secondToLastToken = _a[0], lastToken = _a[1];
            if (!secondToLastToken ||
                !lastToken ||
                secondToLastToken.tokenType.tokenName !== smsTokenMap.Sql.tokenName ||
                lastToken.tokenType.tokenName !== smsTokenMap.LCurly.tokenName) {
                return null;
            }
            var textToMatch = text.slice(startOffset);
            return explicitEndMatcher(textToMatch, '}', FROM_BLOCK_END_MATCHER);
        },
        line_breaks: true,
    }), JsonBlock: createToken({
        name: 'JsonBlock',
        pattern: function (text, startOffset, matchedTokensSoFar) {
            if (startOffset === void 0) { startOffset = 0; }
            var lastToken = matchedTokensSoFar.slice(-1)[0];
            if (!lastToken ||
                lastToken.tokenType.tokenName !== smsTokenMap.Json.tokenName) {
                return null;
            }
            var textToMatch = text.slice(startOffset);
            var match = FROM_JSON_BLOCK_END_MATCHER.exec(textToMatch);
            if (!match) {
                return null;
            }
            var capturedMatch = match.slice(1);
            return capturedMatch;
        },
        line_breaks: true,
    }), GraphQlBlock: createToken({
        name: 'GraphQlBlock',
        pattern: function (text, startOffset, matchedTokensSoFar) {
            if (startOffset === void 0) { startOffset = 0; }
            var _a = matchedTokensSoFar.slice(-2), secondToLastToken = _a[0], lastToken = _a[1];
            if (!secondToLastToken ||
                !lastToken ||
                secondToLastToken.tokenType.tokenName !==
                    smsTokenMap.GraphQl.tokenName ||
                lastToken.tokenType.tokenName !== smsTokenMap.LCurly.tokenName) {
                return null;
            }
            var textToMatch = text.slice(startOffset);
            return explicitEndMatcher(textToMatch, '}', FROM_BLOCK_END_MATCHER);
        },
        line_breaks: true,
    }) });
var smsOnlyTokens = [
    smsTokenMap.Template,
    smsTokenMap.Sql,
    smsTokenMap.GraphQl,
    smsTokenMap.Json,
    smsTokenMap.Csv,
    smsTokenMap.Mapping,
    smsTokenMap.SqlBlock,
    smsTokenMap.JsonBlock,
    smsTokenMap.GraphQlBlock,
];
export var smsTokenTypes = smsOnlyTokens.concat(stardogSparqlTokens);
